export default "__VITE_ASSET__0df22509__"